import React,{useState,useEffect,useContext} from 'react'
import systemMasterServices from '../app/master/systemMasterServices';
import { STATIC_MASTERS } from '../app/master/staticMasters';

import productServices from '../app/admin/erp/finance/product/productServices';

import partyServices from '../app/admin/erp/finance/party/partyServices';

import userServices from '../app/admin/user/userServices';
import userRoleServices from '../app/admin/user/userRoleServices';

import companyServices from '../app/admin/erp/finance/company/companyServices';
import employeeServices from '../app/admin/erp/employee/employeeServices';
import inventoryServices from '../app/admin/erp/finance/inventory/inventoryServices';
import tenderServices from '../app/admin/erp/crm/tender/tenderServices';
import { SYSTEM_MASTERS } from '../app/master/systemsMasters';

import projectServices from '../app/admin/erp/project/projectServices';
import taskServices from '../app/admin/erp/tasks/taskServices';
import ledgerServices from '../app/admin/erp/finance/ledger/ledgerServices';
import ledgerGroupServices from '../app/admin/erp/finance/ledger/ledgerGroupServices';
import companyLocationServices from '../app/admin/erp/finance/company/companyLocationServices';


const AppDataContext = React.createContext();

export const useAppData = () => {
    return useContext(AppDataContext);
}

export const AppDataProvider = (props) =>{
    
    const [loading,setLoadingStatus] = useState(false)
    const [masters,setMasters] = useState(null);
    const [toolbarStatus,setToolbarStatus] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    const [companyList,setCompanyList] = useState(null);
    const [companyDD,  setCompanyDD] = useState(null);

    const [ledgerGroupList,setLedgerGroupList] = useState(null);
    const [ledgerGroupDD,  setLedgerGroupDD] = useState(null);

    const [ledgerList,setLedgerList] = useState(null);
    const [ledgerDD,  setLedgerDD] = useState(null);

    const [productList,setProductList] = useState(null);
    const [productDD,setProductDD] = useState(null);
    
    const [partyList,setPartyList] = useState(null);
    const [partyDD,setPartyDD] = useState(null);

    const [employeeList,setEmployeeList] = useState(null);
    const [employeeDD,  setEmployeeDD] = useState(null);
    
    const [companyLocationList,setCompanyLocationList] = useState(null);
    const [companyLocationDD,setCompanyLocationDD] = useState(null);
    const [projectList,setProjectList] = useState(null);
    const [projectDD, setProjectDD] = useState(null)

    const [tenderList,setTenderList] = useState(null);
    const [tenderDD,  setTenderDD] = useState(null)
    const [taskList,setTaskList] = useState(null);
    const [archivedTaskList,setArchivedTaskList] = useState(null);

    
    const [userDD, setUserDD] = useState(null);
    const [userRoleDD, setUserRoleDD] = useState(null);

    const [inventoryTransactionList,setInventoryTransactionList] = useState(null);
    const [inventoryStockList,setInventoryStockList] = useState(null);

    
    const getMasterList = () => {
        systemMasterServices.get(SYSTEM_MASTERS).then(res=>{
            setMasters({...res,...STATIC_MASTERS});
        }).catch(error=>{
        })
    }
    
    const getMasterLabel = (type, id) => {
        try{
            let label = masters[type].find(m => m.value === id)
            return label.label;
        } catch(e){
            //console.log(type,id);
            return "";
        }
    }
    

    const getCompanyList = () =>{
        setLoadingStatus(true);
        companyServices.getList().then(res=>{
            setCompanyList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getCompanyDD = () =>{
        setLoadingStatus(true);
        companyServices.getDD().then(res=>{
            setCompanyDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getLedgerGroupList = () =>{
        setLoadingStatus(true);
        ledgerGroupServices.getList().then(res=>{
            setLedgerGroupList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getLedgerGroupDD = () =>{
        setLoadingStatus(true);
        ledgerGroupServices.getDD().then(res=>{
            setLedgerGroupDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getLedgerList = () =>{
        setLoadingStatus(true);
        ledgerServices.getList().then(res=>{
            setLedgerList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getLedgerDD = () =>{
        setLoadingStatus(true);
        ledgerServices.getDD().then(res=>{
            setLedgerDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProductList = () =>{
        setLoadingStatus(true);
        productServices.getList().then(res=>{
            setProductList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getProductDD = () =>{
        setLoadingStatus(true);
        productServices.getDD().then(res=>{
            setProductDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getPartyList = () =>{
        setLoadingStatus(true);
        partyServices.getList().then(res=>{
            setPartyList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getPartyDD = () =>{
        setLoadingStatus(true);
        partyServices.getDD().then(res=>{
            setPartyDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getEmployeeList = () =>{
        setLoadingStatus(true);
        employeeServices.getList().then(res=>{
            setEmployeeList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getEmployeeDD = () =>{
        setLoadingStatus(true);
        employeeServices.getDD().then(res=>{
            setEmployeeDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getCompanyLocationList = () =>{
        setLoadingStatus(true);
        companyLocationServices.getList().then(res=>{
            setCompanyLocationList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getCompanyLocationDD = () =>{
        setLoadingStatus(true);
        companyLocationServices.getDD().then(res=>{
            setCompanyLocationDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectList = () =>{
        setLoadingStatus(true);
        projectServices.getList().then(res=>{
            setProjectList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getProjectDD = () =>{
        setLoadingStatus(true);
        projectServices.getDD().then(res=>{
            setProjectDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getTenderList = () =>{
        setLoadingStatus(true);
        tenderServices.getList().then(res=>{
            setTenderList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getTenderDD = () =>{
        setLoadingStatus(true);
        tenderServices.getDD().then(res=>{
            setTenderDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getTaskList = () =>{
        setLoadingStatus(true);
        taskServices.getList().then(res=>{
            setTaskList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }


    const getArchivedTaskList = () =>{
        setLoadingStatus(true);
        taskServices.getArchivedList().then(res=>{
            setArchivedTaskList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
  
    const getUserDD = () =>{
        setLoadingStatus(true);
        userServices.getDD().then(res=>{
            setUserDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getUserRoleDD = () =>{
        setLoadingStatus(true);
        userRoleServices.getDD().then(res=>{
            setUserRoleDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getInventoryTransactionList = (filter) =>{
        setLoadingStatus(true);
        inventoryServices.getTransactionList(filter).then(res=>{
            setInventoryTransactionList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getInventoryStockList = () =>{
        setLoadingStatus(true);
        inventoryServices.getStockList().then(res=>{
            setInventoryStockList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getAppDataById = (dataArray,id) =>{
        try{
            let data =  dataArray?.find(d => d.id === id)
            return data;
        } catch(e){
            //console.log(type,id);
            return "";
        } 
    }

    const getDDDataById = (dataArray,value) =>{
        try{
            let data =  dataArray?.find(d => d.value === Number(value))
            return data;
        } catch(e){
            //console.log(type,id);
            return "";
        } 
    }
    
    

    const value= {
        
        toolbarStatus,setToolbarStatus,
        unreadCount, setUnreadCount,
        masters,getMasterLabel,getMasterList,

        ledgerGroupList,getLedgerGroupList,ledgerGroupDD,getLedgerGroupDD,
        ledgerList,getLedgerList,ledgerDD,getLedgerDD,

        companyList,getCompanyList, companyDD,getCompanyDD,
        tenderList,getTenderList,tenderDD,getTenderDD,
        employeeList,getEmployeeList, employeeDD,getEmployeeDD,
        productList,getProductList, productDD,getProductDD,
        partyList,getPartyList, partyDD,getPartyDD,
        companyLocationList,getCompanyLocationList,companyLocationDD,getCompanyLocationDD,
        projectList,getProjectList, projectDD,getProjectDD,
        taskList,getTaskList,
        archivedTaskList,getArchivedTaskList,
        
        userDD,getUserDD,
        userRoleDD,getUserRoleDD,

        inventoryTransactionList,getInventoryTransactionList,
        inventoryStockList,getInventoryStockList,

        getAppDataById, getDDDataById,
        loading
    }

    useEffect(()=>{
        getMasterList();
        getLedgerGroupDD();
        getLedgerDD();
        getCompanyDD();
        getProductDD();        
        getPartyDD();
        getEmployeeDD();
        getCompanyLocationDD();
        getProjectDD();
        getTenderDD();
        getUserDD();
        getUserRoleDD();
        getTaskList();
    },[])
    
    return (
        masters && companyDD && productDD &&  partyDD &&  employeeDD &&  companyLocationDD && projectDD  && tenderDD && userDD && userRoleDD && ledgerGroupDD && ledgerDD &&
        taskList &&
        <AppDataContext.Provider value= {value}>{props.children}</AppDataContext.Provider>
    )
}